import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
  Col,
  Row,
  Table,
  Button,
  CardHeader,
  Input,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledCollapse,
  Badge,
  FormGroup,
  Label,
} from "reactstrap";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ReactBsTable from "components/Tables/ReactBsTable";
import DynamicFormModal from "components/Modal/Form";
import { insertionOrderFormFields } from "variables/formFields";
import { INSERTION_ORDER_STATUS_LABELS } from "variables/constants";
import Breadcrumbs from "components/BreadCrumb/Breadcrumbs";
import DocumentPreviewModal from "pages/DocPreview/DocPreviewModal";
import { getPublisherDetailsById } from "actions/publisher";
import NotificationAlert from "react-notification-alert";
import { getPublisherList } from "actions/publisher";
import { getInsertionOrderList } from "actions/insertionOrder";
import { billing_info_by_publisher_id } from "API";
import { billingInfoByPublisherId } from "actions/publisher";
import { updateBillingInfoByPublisherId } from "actions/publisher";
import { advertiserBlockList } from "actions/publisher";
import { downloadAdvertiserBlockList } from "actions/publisher";
import { adsUploadFile } from "actions/publisher";
import { advertizeListUploadFile } from "actions/publisher";
import { getAdvertizeListFile } from "actions/publisher";
import { getAdsFile } from "actions/publisher";
import { getAdvertiserBlockList } from "actions/publisher";
import { downloadAdvertiseTxt } from "actions/publisher";
import { downloadAdsTxt } from "actions/publisher";
import { downloadInsertionOrder } from "actions/insertionOrder";
import { FALCON_BASE_URL } from "API/apiConstants";
import { download_insertion_order } from "API";
import moment from "moment";
import { createInsertionOrder } from "actions/insertionOrder";
import { DataTableData } from "variables/general";
import { getAdvertiserBlockListLogs } from "actions/publisher";
import { getAdvertiserLogsList } from "actions/publisher";
import { getAdsLogsList } from "actions/publisher";
import { getInsertionOrderHistory } from "actions/insertionOrder";
import { bankInfoDetails } from "actions/publisher";
import BankDetailModal from "components/Modal/BankDetailModal";
import { createPublisherBillingInfo } from "actions/publisher";
import { bankDetailsHistoryList } from "actions/publisher";

let publisherData;

const sortFieldMap = {
  name: "Name",
  startDate: "StartDate",
  endDate: "EndDate",
  version: "Version",
  documentStatus: "DocumentStatus",
};

function PublisherDetails() {
  const location = useLocation();
  const storedUser = JSON.parse(localStorage.getItem("p") || "{}");
  const publisherFromState = location.state?.publisher || location.state || {};
  const publisher = publisherFromState?.ID ? publisherFromState : {
    ID: publisherFromState?.ID || storedUser?.publisherID || storedUser?.ID,
    companyName: publisherFromState?.companyName || storedUser?.name || "Publisher",
  };
  const publisherId = publisher?.ID || storedUser?.publisherID || storedUser?.ID;
  const fileInputRef = useRef(null);
  const adsFileInputRef = useRef(null);
  const [searchParams] = useSearchParams();
  const urlTab = searchParams.get("tab");
  const notificationAlertRef = useRef(null);
  const [showLoader, setshowLoader] = useState(false);
    const [bankHistory, setBankHistory] = useState([]);
  const [publisherTabData, setpublisherTabData] = useState([]);
  const [csvDocument, setCsvDocument] = useState({
    adsDocument: {},
    advertizeDocument: {},
    advertizeBlockList: {},
  });
  const [dropDownData, setDropDownData] = useState({
    publisherData: {
      options: [],
      pageNum: 1,
      searchString: "",
      totalRecords: 0,
    },
  });
  const [ioData, setIoData] = useState([]);
  const [rowData, setRowData] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [preview, setPreview] = useState(null);
  const [csvPreviewModal, setCsvPreviewModal] = useState(false);
  const [csvPreviewUrl, setCsvPreviewUrl] = useState("");
  const [ioListApiData, setioListApiData] = useState({
    pageNum: 1,
    filterParams: [],
    searchString: "",
    totalRecords: 0,
  });
  const [billingInfoForm, setbillingInfoForm] = useState({
    legal_entity_name: { value: "", error: "" },
    recipient_name: { value: "", error: "" },
    bank_name: { value: "", error: "" },
    country: { value: "", error: "" },
    billing_address: { value: "", error: "" },
    trn_vat_id: { value: "", error: "" },
    payment_currency: { value: "", error: "" },
    recipient_address: { value: "", error: "" },
    bank_account: { value: "", error: "" },
    account_number: { value: "", error: "" },
    bank_address: { value: "", error: "" },
    iban: { value: "", error: "" },
    swift_bic: { value: "", error: "" },
    swift_code: { value: "", error: "" },
    routing_number: { value: "", error: "" },
    ifsc_code: { value: "", error: "" },
    invoice_email: { value: "", error: "" },
    tax_residency: { value: "", error: "" },
    payment_terms: { value: "", error: "" },
    minimum_payout: { value: "", error: "" },
    approval_status: { value: "", error: "" },
    created_at: { value: "", error: "" },
    updated_at: { value: "", error: "" },
    approved_by: { value: "", error: "" },
    approved_at: { value: "", error: "" },
  });

  const [formState, setFormState] = useState({
    values: { status: true, publisher: publisherId },
    errors: {},
  });
  const [csvData, setCSVData] = useState({
    data: DataTableData,
    AdvertiserBlockListLogs: { data: [], totalRecords: 0 },
    AdvertiserListLogs: { data: [], totalRecords: 0 },
    AdsListLogs: { data: [], totalRecords: 0 },
    totalRecords: 6,
  });
    const [historyLoader, setHistoryLoader] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
    const [isBankModalOpen, setIsBankModalOpen] = useState(false);
  
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    dataField: "",
    sortField: "",
    sortOrder: "",
  });

  const isEditMode = !!selected;
  const disabledPublisherDropdown = true;
  const userRole = storedUser?.role || "";
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  const [activeTab, setActiveTab] = useState(urlTab || "details");

  useEffect(() => {
    if (publisherId) {
      getPublisherDetails();
    }
  }, [publisherId]);

  React.useEffect(() => {
    if (publisherId) {
      fetchBlockList();
    }
  }, [publisherId]);

  const fetchBlockList = async () => {
    try {
      if (!publisherId) return;
      const res = await getAdsFile(publisherId);
      const advertizeRes = await getAdvertizeListFile(publisherId);
      const blockListres = await getAdvertiserBlockList(publisherId);
      const advertiseblockListLogs = await getAdvertiserBlockListLogs(
        publisherId,
      );
      const advertiseListLogs = await getAdvertiserLogsList(publisherId);
      const adsLogsList = await getAdsLogsList(publisherId);
      setCSVData((prev) => ({
        ...prev,
        AdvertiserBlockListLogs: {
          data: advertiseblockListLogs?.data?.AdvertiseBlocklistVersion,
          totalRecords: advertiseblockListLogs?.data.totalRecords,
        },
        AdvertiserListLogs: {
          data: advertiseListLogs?.data.AdvertiseListVersion,
          totalRecords: advertiseListLogs?.data.totalRecords,
        },
        AdsListLogs: {
          data: adsLogsList?.data.AdsTxtVersion,
          totalRecords: adsLogsList?.data.totalRecords,
        },
      }));
      setCsvDocument({
        ...csvDocument,
        adsDocument: res?.data,
        advertizeDocument: advertizeRes.data,
        blockList: blockListres.data,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const getPublisherDetails = async () => {
    if (!publisherId) return;
    try {
      const res = await getPublisherDetailsById(publisherId);
      if (res.code === 200) {
        setpublisherTabData(res?.data);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {}
  };

  useEffect(() => {
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        publisher: publisherId || prev.values.publisher,
      },
    }));
  }, [publisherId]);

  useEffect(() => {
    if (urlTab && urlTab !== activeTab) {
      setActiveTab(urlTab);
    }
  }, [urlTab]);

  const getDropDownData = async () => {
    try {
      const publisherRes = await getPublisherList();
      const publisherData =
        publisherRes?.code === 200
          ? (publisherRes?.data?.Publisher || []).map((item) => ({
              label: item?.companyName || "",
              value: item?.ID,
            }))
          : [];
      setDropDownData((prev) => ({
        ...prev,
        publisherData: {
          ...prev.publisherData,
          options: publisherData,
          totalRecords: publisherRes.totalRecords,
        },
      }));
    } catch (error) {}
  };

  const getInsertionOrderListData = async () => {
    if (!publisherId) return;
    try {
      setshowLoader(true);
      const res = await getInsertionOrderHistory(
        publisherId,
        sortConfig.sortField,
        sortConfig.sortOrder,
        pageNum,
        pageSize
      );
      if (res.code === 200) {
        setshowLoader(false);
        setIoData(res?.data?.InsertionOrder || []);
        setTotalRecords(res?.data?.totalRecords || 0);
      } else {
        setshowLoader(false);
        setIoData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      setshowLoader(false);
    }
  };

  useEffect(() => {
    if (activeTab === "insertion-orders") {
      getInsertionOrderListData();
    }
  }, [pageNum, pageSize, sortConfig.sortField, sortConfig.sortOrder, activeTab]);

  useEffect(() => {
    if (!publisherId) return;
    getBillingInfo();
    getBankHistory();
  }, [publisherId]);

  //==> getBillingInfo function - Updated for new API
  const getBillingInfo = async () => {
    if (!publisherId) return;
    try {
      const res = await billingInfoByPublisherId(publisherId);
      if (res.code === 200) {
        let data = res?.data;
        setbillingInfoForm({
          companyName: { value: publisherTabData?.companyName || publisher?.companyName || "", error: "" },
          legal_entity_name: { value: publisherTabData?.companyName || "", error: "" },
          recipient_name: { value: data?.recipientName || data?.accountName || "", error: "" },
          bank_name: { value: data?.bankName || "", error: "" },
          country: { value: data?.countryName || data?.country || "", error: "" },
          billing_address: { value: data?.billingAddress || "", error: "" },
          trn_vat_id: { value: data?.vatNumber || "", error: "" },
          payment_currency: { value: data?.paymentCurrency || "", error: "" },
          recipient_address: { value: data?.recipientAddress || "", error: "" },
          bank_account: { value: data?.bankAccount || data?.accountNumber || "", error: "" },
          account_number: { value: data?.accountNumber || "", error: "" },
          bank_address: { value: data?.bankAddress || "", error: "" },
          iban: { value: data?.iban || "", error: "" },
          swift_bic: { value: data?.swiftBic || data?.swiftCode || "", error: "" },
          swift_code: { value: data?.swiftCode || "", error: "" },
          routing_number: { value: data?.routingNumber || "", error: "" },
          ifsc_code: { value: data?.ifscCode || "", error: "" },
          invoice_email: { value: data?.invoiceEmail || "", error: "" },
          tax_residency: { value: data?.taxResidency || "", error: "" },
          payment_terms: { value: data?.paymentTerms || "", error: "" },
          minimum_payout: { value: data?.minimumPayout || "", error: "" },
          approval_status: { value: data?.approvalStatus || "", error: "" },
          created_at: { value: data?.createdAt || "", error: "" },
          updated_at: { value: data?.updatedAt || "", error: "" },
          approved_by: { value: data?.approvedBy || "", error: "" },
          approved_at: { value: data?.approvedAt || "", error: "" },
        });
      }
    } catch (error) {
      console.error("Error fetching billing info:", error);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab === tab) return;

    if (tab === "insertion-orders") {
      getDropDownData();
      getInsertionOrderListData();
    }

    if (tab === "billing-info") {
      getBillingInfo();
      getBankHistory();
    }

    setActiveTab(tab);
  };

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const billingInfoHandleChange = (key, value) => {
    setbillingInfoForm((prev) => ({
      ...prev,
      [key]: { value: value, error: "" },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormState((prev) => {
      const updatedValues = {
        ...prev.values,
        [name]: value,
      };

      const { startDate, endDate } = updatedValues;

      if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
        updatedValues.endDate = "";
      }

      return {
        values: updatedValues,
        errors: {
          ...prev.errors,
          [name]: "",
        },
      };
    });
  };

  const validateForm = () => {
    const errors = {};

    insertionOrderFormFields(dropDownData.publisherData.options).forEach(
      (f) => {
        if (f.required && !formState.values[f.name]) {
          errors[f.name] = `${f.label} is required`;
        }
      },
    );

    const { startDate, document } = formState.values;

    if (!document) {
      errors.document = "Document is required.";
    }

    setFormState((prev) => ({ ...prev, errors }));
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setshowLoader(true);
    try {
      const payload = {
        name: formState.values.ioName,
        publisherID: Number(formState.values.publisher),
        documentStatus: formState?.values.status ? "SIGNED" : "UNSIGNED",
        version: "1",
      };

      if (formState.values.startDate) {
        payload.startDate = moment
          .utc(formState.values.startDate, "YYYY-MM-DD")
          .startOf("day")
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }

      if (formState.values.endDate) {
        payload.endDate = moment
          .utc(formState.values.endDate, "YYYY-MM-DD")
          .endOf("day")
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }

      const formData = new FormData();

      formData.append("ioData", JSON.stringify(payload));

      if (Array.isArray(formState.values.document)) {
        formState.values.document.forEach((file) => {
          formData.append("pdf", file);
        });
      } else {
        formData.append("pdf", formState.values.document);
      }

      const res = await createInsertionOrder(formData);

      if (res.code === 200) {
        setshowLoader(false);
        notify("success", res?.message);
        getInsertionOrderListData();
        setModalOpen(false);
        setSelected(null);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
        setshowLoader(false);
      }
    } catch (err) {
      setshowLoader(false);
      notify("danger", "Upload failed");
    }
  };

  //==> updateBillingInfo function - Updated for new API
  const updateBillingInfo = async () => {
    try {
      const payload = {
        id: publisherId,
        legalName: billingInfoForm.legal_entity_name.value,
        billingAddress: billingInfoForm.billing_address.value,
        country: billingInfoForm.country.value,
        vatNumber: billingInfoForm.trn_vat_id.value,
        taxResidency: billingInfoForm.tax_residency.value,
        paymentCurrency: billingInfoForm.payment_currency.value,
        paymentTerms: billingInfoForm.payment_terms.value,
        minimumPayout: parseFloat(billingInfoForm.minimum_payout.value) || 0,
        bankName: billingInfoForm.bank_name.value,
        accountName: billingInfoForm.recipient_name.value,
        accountNumber: billingInfoForm.bank_account.value,
        iban: billingInfoForm.iban.value,
        swiftCode: billingInfoForm.swift_bic.value || billingInfoForm.swift_code.value,
        ifscCode: billingInfoForm.ifsc_code.value,
        invoiceEmail: billingInfoForm.invoice_email.value,
        recipientName: billingInfoForm.recipient_name.value,
        recipientAddress: billingInfoForm.recipient_address.value,
        routingNumber: billingInfoForm.routing_number.value,
      };
      
      const res = await updateBillingInfoByPublisherId(payload);
      if (res.code === 200) {
        notify("success", "Billing Info Updated Successfully");
        getBillingInfo();
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating billing info:", error);
      notify("danger", "Failed to update billing info");
    }
  };

  const downloadBlocklistCsv = async () => {
    try {
      const response = await downloadAdvertiserBlockList(publisherId);

      let csvData = "";

      if (typeof response === "string") {
        csvData = response;
      } else if (response?.data) {
        if (typeof response.data === "string") {
          csvData = response.data;
        } else if (Array.isArray(response.data)) {
          csvData = response.data.join("\n");
        } else {
          csvData = JSON.stringify(response.data);
        }
      } else if (response?.csv) {
        csvData = response.csv;
      }

      if (!csvData) {
        notify("danger", "No data received from server");
        return;
      }

      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "advertiser_block_list.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      notify("success", "Blocklist downloaded successfully");
    } catch (err) {
      console.error("Download failed", err);
      notify("danger", "Failed to download blocklist");
    }
  };

  const downloadlistCsv = async () => {
    try {
      const response = await downloadAdvertiseTxt(publisherId);

      let csvData = "";

      if (typeof response === "string") {
        csvData = response;
      } else if (response?.data) {
        if (typeof response.data === "string") {
          csvData = response.data;
        } else if (Array.isArray(response.data)) {
          csvData = response.data.join("\n");
        } else {
          csvData = JSON.stringify(response.data);
        }
      } else if (response?.csv) {
        csvData = response.csv;
      }

      if (!csvData) {
        notify("danger", "No data received from server");
        return;
      }

      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "advertiser_list.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      notify("success", "Blocklist downloaded successfully");
    } catch (err) {
      console.error("Download failed", err);
      notify("danger", "Failed to download blocklist");
    }
  };

  const downloadADSListCsv = async () => {
    try {
      const response = await downloadAdsTxt(publisherId);

      let csvData = "";

      if (typeof response === "string") {
        csvData = response;
      } else if (response?.data) {
        if (typeof response.data === "string") {
          csvData = response.data;
        } else if (Array.isArray(response.data)) {
          csvData = response.data.join("\n");
        } else {
          csvData = JSON.stringify(response.data);
        }
      } else if (response?.csv) {
        csvData = response.csv;
      }

      if (!csvData) {
        notify("danger", "No data received from server");
        return;
      }

      const blob = new Blob([csvData], { type: "text/plain;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "ADS_list.txt";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      notify("success", "Blocklist downloaded successfully");
    } catch (err) {
      console.error("Download failed", err);
      notify("danger", "Failed to download blocklist");
    }
  };

  const openCsvPreviewModal = (fileUrl) => {
    setCsvPreviewUrl(fileUrl);
    setCsvPreviewModal(true);
  };

  const ioColumns = [
    {
      dataField: "name",
      text: "IO Name",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "version",
      text: "Version",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      text: "Document",
      dataField: "fileUrl",
      formatter: (_, row) =>
        row.fileUrl ? (
          <span
            className="text-info"
            onClick={(e) => {
              openCsvPreviewModal(row.fileUrl);
              setRowData(row);
            }}
            style={{ cursor: "pointer" }}
          >
            {row.fileName}
          </span>
        ) : (
          "-"
        ),
    },
    {
      dataField: "documentStatus",
      text: "Status",
      formatter: (cell) => (
        <Badge color={cell === "SIGNED" ? "success" : "warning"}>{cell}</Badge>
      ),
    },
    {
      text: "Actions",
      dataField: "actions",
      formatter: (_, row) => (
        <div className="d-flex align-items-center">
          <a
            id={`view${row.id}`}
            className="table-action table-action-info"
            onClick={(e) => {
              openCsvPreviewModal(row.fileUrl);
              setRowData(row);
            }}
          >
            <i className="fas fa-eye" />
          </a>
          <UncontrolledTooltip target={`view${row.id}`}>
            View Document
          </UncontrolledTooltip>

          <a
            id={`download${row.id}`}
            className="table-action table-action-delete"
            onClick={(e) => {
              e.stopPropagation();
              downloadIO(row);
            }}
          >
            <i className="fas fa-download" />
          </a>
          <UncontrolledTooltip target={`download${row.id}`}>
            Download Document
          </UncontrolledTooltip>
        </div>
      ),
    },
  ];

  const handleSortChange = (dataField, sortOrder) => {
    const mappedSortField = sortFieldMap[dataField] || dataField;
    setSortConfig({ dataField, sortField: mappedSortField, sortOrder });
    setPageNum(1);
  };

  const handlePageChange = (page) => {
    setPageNum(page);
  };

  const handleSizePerPageChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);
    setPageNum(1);
  };

  const downloadIO = async (row) => {
    try {
      const response = await download_insertion_order(row.ID);

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      const filename =
        row.fileName && row.fileName.endsWith(".pdf")
          ? row.fileName
          : `${row.fileName || "insertion-order"}.pdf`;

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      notify("success", "PDF downloaded successfully");
    } catch (err) {
      console.error(err);
      notify("danger", "Failed to download PDF");
    }
  };

  const downloadPdf = (pdfString, row) => {
    const blob = new Blob([pdfString], { type: "application/pdf" });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${row?.fileName}`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const getTrimmedFileName = (fileUrl, maxLength = 20) => {
    if (!fileUrl) return "";

    const fileName = decodeURIComponent(fileUrl.split("/").pop());

    if (fileName.length <= maxLength) return fileName;

    return `${fileName.slice(0, maxLength)}...`;
  };

  const columns = [
    {
      text: "Sr. No.",
      dataField: "srNo",
      formatter: (_, __, rowIndex) => (pageNum - 1) * 10 + rowIndex + 1,
    },
    {
      text: "Document",
      dataField: "fileUrl",
      formatter: (_, row) =>
        row.fileUrl ? (
          <span
            className="text-info"
            onClick={() => openCsvPreviewModal(row.fileUrl)}
            style={{ cursor: "pointer" }}
            title={decodeURIComponent(row.fileUrl.split("/").pop())}
          >
            {getTrimmedFileName(row.fileUrl)}
          </span>
        ) : (
          "-"
        ),
    },
    {
      dataField: "version",
      text: "version",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => (
        <Badge color={cell === "ACTIVE" ? "success" : "danger"}>{cell}</Badge>
      ),
    },
    {
      dataField: "createdAt",
      text: "Created On",
      formatter: (_, row) => (row?.createdAt != "" ? row?.createdAt : "-"),
    },
    {
      dataField: "updatedAt",
      text: "Updated On",
      formatter: (_, row) => (row?.updatedAt != "" ? row?.updatedAt : "-"),
    },
  ];

  const CardSection = ({
    header,
    paragraph,
    btntext,
    showTextArea = false,
    showuploadIcon = false,
    showDownloadIcon = false,
    showUploadCsvbtn = false,
    uploadcsvtext,
    uploadcsvbtnclick,
    onClick,
    showViewButton = false,
    showDivider = false,
    rightContent,
    tableHeading,
    tableDescription,
    collapseId,
    data,
    onPageChange,
    pageNum,
  }) => {
    const togglerId = `toggler-${collapseId}`;
    return (
      <Container fluid className="mt-2">
        <CardBody className="card-section-wrapper">
          <div className="card-left">
            <h4 className="advertiser-title">{header}</h4>
            <p className="advertiser-subtitle">{paragraph}</p>

            <div className="display-flex">
              {showUploadCsvbtn && (
                <Button
                  className="btn-gradient-primary mr-2"
                  onClick={uploadcsvbtnclick}
                >
                  <i className="fa fa-upload mr-2" />
                  {uploadcsvtext}
                </Button>
              )}

              <Button className="btn-gradient-primary" onClick={onClick}>
                {showuploadIcon && <i className="fa fa-upload mr-2" />}
                {showDownloadIcon && <i className="fa fa-download mr-2" />}
                {btntext}
              </Button>
            </div>

            {showTextArea && (
              <textarea
                className="ads-textarea mt-3"
                rows="5"
                disabled
                defaultValue={`google.com, pub-0000000000000000, DIRECT, f08c47fec0942fa0
example.com, 12345, RESELLER, abcdef123456`}
              />
            )}
          </div>

          {showDivider && <div className="vertical-divider" />}
          <div className="card-right">
            {rightContent}

            {showViewButton && (
              <Button color="info" outline className="mt-2">
                Info
              </Button>
            )}
          </div>
        </CardBody>
        <div>
          <Button
            color="secondary"
            id={togglerId}
            size="sm"
            className="ml-3 mb-3"
          >
            View Logs
          </Button>

          <UncontrolledCollapse toggler={`#${togglerId}`}>
            <Container fluid>
              <ReactBsTable
                title={tableHeading}
                description={tableDescription}
                data={data.data}
                columns={columns}
                showAddbtn={false}
                keyField="ID"
                enablePagination={false}
                totalRecords={data?.totalRecords}
                onSortChange={handleSortChange}
              />
            </Container>
          </UncontrolledCollapse>
        </div>
      </Container>
    );
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("Selected file:", file.name);
    }
  };

  const handleUploadAdsFile = (event) => {
    adsFileInputRef.current.click();
  };

  const uploadAdsFile = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const fileName = file.name.toLowerCase();

    if (!fileName.endsWith(".txt")) {
      notify("danger", "Only TXT files are allowed");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("document", file);

      const res = await adsUploadFile(formData, publisherId);

      if (res?.code === 200) {
        notify("success", "File uploaded successfully");
      } else {
        notify("danger", res?.message || "Upload failed");
      }
    } catch (err) {
      notify("danger", "Something went wrong while uploading");
    }
    e.target.value = "";
    fetchBlockList();
  };
  const handleUploadAdvertizeFile = (event) => {
    fileInputRef.current.click();
  };

  const getBankHistory = async () => {
      setHistoryLoader(true);
      try {
        const res = await bankDetailsHistoryList(publisherId);
        if (res?.code === 200) {
          // The response data is an array of objects
          const dataArray = res?.data?.PublisherBillingInfo || [];
          // Map the response data to match the table format
          const historyData = dataArray.map(item => ({
            id: item.id,
            legal_entity_name: item.legalName || "-",
            recipient_name: item.accountName || item.recipientName || "-",
            country: item.countryName || "-",
            taxResidency:item.taxResidency||"-",
            billing_address: item.billingAddress || "-",
            trn_vat_id: item.vatNumber || "-",
            payment_currency: item.paymentCurrency || "-",
            bank_name: item.bankName || "-",
            bank_account: item.accountNumber || item.bankAccount || "-",
            bank_address: item.bankAddress || "-",
            iban: item.iban || "-",
            swift_bic: item.swiftCode || item.swiftBic || "-",
            routing_number: item.routingNumber || "-",
            ifsc_code: item.ifscCode || "-",
            invoice_contact_email: item.invoiceEmail || "-",
            tax_residency: item.taxResidency || "-",
            status: item.status || "INACTIVE",
            rejection_reason: item.rejectionReason || "-",
            approval_status: item.approvalStatus || "PENDING",
            updated_at: item.updatedAt || "-",
            approved_by: item.approvedBy || "-",
            approved_at: item.approvedAt || "-",
            created_at: item.createdAt || "-",
            payment_terms: item.paymentTerms || "-",
            minimum_payout: item.minimumPayout || 0,
          }));
          setBankHistory(historyData);
        } else {
          setBankHistory([]);
        }
      } catch (error) {
        console.error("Error fetching bank history:", error);
        setBankHistory([]);
      } finally {
        setHistoryLoader(false);
      }
    };
  


  //==> handleBankSubmit function
    const handleBankSubmit = async (payload) => {
  
      try {
        setshowLoader(true);
        
        // Prepare the payload matching the Go struct
        const apiPayload = {
          publisherID: publisherId,
          legalName: payload.billingInfo.legalEntityName || payload.billingInfo.legal_entity_name,
          billingAddress: payload.billingInfo.billingAddress || payload.billingInfo.billing_address,
          country: parseInt(payload.billingInfo.country) || 0,
          vatNumber: payload.billingInfo.trnVatId || payload.billingInfo.trn_vat_id || "",
          paymentTerms: payload.billingInfo.paymentTerms || payload.billingInfo.payment_terms || "Net 30",
          minimumPayout: parseFloat(payload.billingInfo.minimumPayout) || 500,
          bankName: payload.billingInfo.bankName || payload.billingInfo.bank_name,
          accountNumber: payload.billingInfo.bankAccount || payload.billingInfo.bank_account,
          iban: payload.billingInfo.iban || "",
          swiftCode: payload.billingInfo.swiftBic || payload.billingInfo.swift_bic,
          ifscCode: payload.billingInfo.ifscCode || payload.billingInfo.ifsc_code || "",
          invoiceEmail: payload.billingInfo.contactEmail || payload.billingInfo.contact_email || payload.billingInfo.invoice_email,
          recipientName: payload.billingInfo.recipientName || payload.billingInfo.recipient_name || payload.billingInfo.legalEntityName,
          recipientAddress: payload.billingInfo.recipientAddress || payload.billingInfo.recipient_address,
          taxResidency: payload.billingInfo.taxResidency || payload.billingInfo.tax_residency || "",
          paymentCurrency: payload.billingInfo.paymentCurrency || payload.billingInfo.payment_currency || "USD",
          routingNumber: payload.billingInfo.routingNumber || payload.billingInfo.routing_number || "",
        };
  
        const res = await createPublisherBillingInfo(apiPayload);
        
        if (res.code === 200) {
          notify("success", "Bank details saved successfully! Awaiting admin approval.");
          setshowLoader(false);
          await Promise.all([getBillingInfo(), getBankHistory()]);
          return { code: 200 };
        } else {
          setshowLoader(false);
          const message = Array.isArray(res?.message)
            ? res?.message[0]?.Msg
            : res?.message || "Failed to save bank details";
          notify("danger", message);
          return { code: res.code, message: message };
        }
      } catch (error) {
        setshowLoader(false);
        console.error("Error saving bank details:", error);
        notify("danger", "Something went wrong while saving bank details");
        return { code: 500, message: "Something went wrong" };
      }
    };

  const uploadAdvertizeListFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith(".csv")) {
      notify("danger", "Only CSV files are allowed");
      e.target.value = "";
      return;
    }

    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      notify("danger", "File size should not exceed 10 MB");
      e.target.value = "";
      return;
    }

    try {
      const formData = new FormData();
      formData.append("document", file);

      const res = await advertizeListUploadFile(formData, publisherId);

      if (res?.code === 200) {
        notify("success", "File uploaded successfully");
      } else {
        notify("danger", res?.message || "Upload failed");
      }
    } catch (err) {
      notify("danger", "Something went wrong while uploading");
    }

    e.target.value = "";
    fetchBlockList();
  };

  const closeCsvPreviewModal = () => {
    setCsvPreviewModal(false);
    setCsvPreviewUrl("");
  };

  const hasBillingInfo = Object.values(billingInfoForm).some(
    (field) => field.value?.trim() !== "",
  );

  const getBillingValue = (key, fallback = "") =>
    billingInfoForm?.[key]?.value ?? fallback;

  const getStatusBadge = (status) => {
    const statusMap = {
      APPROVED: { color: "success", label: "Approved" },
      PENDING: { color: "warning", label: "Pending" },
      REJECTED: { color: "danger", label: "Rejected" },
      ACTIVE: { color: "primary", label: "Active" },
      INACTIVE: { color: "secondary", label: "Inactive" },
    };
    const s = statusMap[status] || statusMap.PENDING;
    return <Badge color={s.color}>{s.label}</Badge>;
  };

  const bankHistoryColumns = [
    {
      dataField: "legal_entity_name",
      text: "Legal Entity Name",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "country",
      text: "Country",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "billing_address",
      text: "Billing Address",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "trn_vat_id",
      text: "TRN/VAT ID",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "payment_currency",
      text: "Currency",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "payment_terms",
      text: "Payment Terms",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "minimum_payout",
      text: "Min Payout",
      formatter: (cell) => (cell ? `$${cell}` : "-"),
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "bank_name",
      text: "Bank Name",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "bank_account",
      text: "Account Number",
      formatter: (cell) => {
        if (!cell) return "-";
        if (cell.length > 4) return "XXXX" + cell.slice(-4);
        return cell;
      },
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "iban",
      text: "IBAN",
      formatter: (cell) => {
        if (!cell) return "-";
        if (cell.length > 8) return cell.slice(0, 4) + "XXXX" + cell.slice(-4);
        return cell;
      },
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "swift_bic",
      text: "SWIFT/BIC",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "taxResidency",
      text: "IFSC Code",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
        {
      dataField: "taxResidency",
      text: "Tax Recidency",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
{
  dataField: "approval_status",
  text: "Approval Status",
  formatter: (cell, row) => {
    const hasRejectionReason = row.rejection_reason && row.rejection_reason !== "-";
    const badge = getStatusBadge(cell);
    
    return (
      <div 
        title={hasRejectionReason ? `Rejection Reason: ${row.rejection_reason}` : ""}
        style={{ display: 'inline-block' }}
      >
        {badge}
      </div>
    );
  },
  headerStyle: { fontWeight: "bold" }
},
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => getStatusBadge(cell === "ACTIVE" ? "ACTIVE" : "INACTIVE"),
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "created_at",
      text: "Created At",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
    {
      dataField: "updated_at",
      text: "Updated At",
      formatter: (cell) => cell || "-",
      headerStyle: { fontWeight: "bold" },
    },
  ];

  //==> Render Billing Field Component
  const BillingField = ({ label, value, isEditing, onChange, name }) => (
    <Col md={6} className="mb-2">
      <FormGroup className="has-label d-flex flex-column align-items-start">
        <Label>{label}</Label>
        {isEditing ? (
          <Input
            name={name}
            value={value}
            onChange={(e) => onChange(name, e.target.value)}
          />
        ) : (
          <span className="small-text">{value || "-"}</span>
        )}
      </FormGroup>
    </Col>
  );

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <Modal
        isOpen={csvPreviewModal}
        toggle={closeCsvPreviewModal}
        className="modal-md"
        style={{ maxWidth: "70%" }}
      >
        <ModalHeader toggle={closeCsvPreviewModal}>
          {csvPreviewUrl === csvDocument?.blockList?.fileUrl
            ? "Advertiser Block List Preview"
            : csvPreviewUrl === csvDocument?.advertizeDocument?.fileUrl
              ? "Advertiser List Preview"
              : csvPreviewUrl === csvDocument?.adsDocument?.fileUrl
                ? "ADS List Preview"
                : "Document Preview"}
          <Button
            color="info"
            size="sm"
            className="ml-2"
            onClick={() => {
              if (csvPreviewUrl === csvDocument?.blockList?.fileUrl) {
                downloadBlocklistCsv();
              } else if (
                csvPreviewUrl === csvDocument?.advertizeDocument?.fileUrl
              ) {
                downloadlistCsv();
              } else if (csvPreviewUrl === csvDocument?.adsDocument?.fileUrl) {
                downloadADSListCsv();
              } else {
                downloadIO(rowData);
              }
            }}
          >
            <i className="fa fa-download mr-1" /> Download
          </Button>
        </ModalHeader>
        <ModalBody style={{ height: "70vh", padding: 0 }}>
          {csvPreviewUrl ? (
            <iframe
              src={csvPreviewUrl}
              title="CSV Preview"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          ) : (
            <div className="text-center p-5">
              <p>No document available for preview</p>
            </div>
          )}
        </ModalBody>
      </Modal>
      <Container fluid className="mt--6">
        <Card className="shadow-sm">
          <Breadcrumbs />

          <Nav className="custom-tabs">
            <NavItem as="li">
              <NavLink
                className={activeTab === "details" ? "active" : ""}
                onClick={() => toggleTab("details")}
              >
                Publisher Details
              </NavLink>
            </NavItem>

            <NavItem as="li">
              <NavLink
                className={activeTab === "insertion-orders" ? "active" : ""}
                onClick={() => toggleTab("insertion-orders")}
              >
                Insertion Orders
              </NavLink>
            </NavItem>

            <NavItem as="li">
              <NavLink
                className={activeTab === "billing-info" ? "active" : ""}
                onClick={() => toggleTab("billing-info")}
              >
                Billing Information
              </NavLink>
            </NavItem>
            <NavItem as="li">
              <NavLink
                className={activeTab === "actions" ? "active" : ""}
                onClick={() => toggleTab("actions")}
              >
                Actions
              </NavLink>
            </NavItem>
          </Nav>

          <CardBody>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="details">
                <Row className="justify-content-center">
                  <Col md={12} lg={12}>
                    <Row className="px-3">
                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Company Name</Label>
                          <span className="small-text">
                            {publisherTabData?.companyName || "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Primary Email</Label>
                          <span className="small-text">
                            {publisherTabData?.email || "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Phone</Label>
                          <span className="small-text">
                            {publisherTabData?.pocPhone || "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>POC Name</Label>
                          <span className="small-text">
                            {publisherTabData?.pocFirstName ||
                            publisherTabData?.pocLastName
                              ? `${publisherTabData?.pocFirstName || ""} ${
                                  publisherTabData?.pocLastName || ""
                                }`.trim()
                              : "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Accounting Email</Label>
                          <span className="small-text">
                            {publisherTabData?.accountingEmail || "-"}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Reporting Emails</Label>
                          <span className="small-text">
                            {publisherTabData?.reportingEmail || "-"}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>GAM Network ID</Label>
                          <span className="small-text">
                            {publisherTabData?.gamNetworkID || "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Product Type</Label>
                          <span className="small-text">
                            {publisherTabData?.productType
                              ?.map((pt) => pt.name)
                              .join(", ") || "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Status</Label>
                          <Badge
                            className="px-3 py-2"
                            color={
                              publisherTabData?.status === "ACTIVE"
                                ? "success"
                                : "danger"
                            }
                            pill
                          >
                            {publisherTabData?.status}
                          </Badge>
                        </FormGroup>
                      </Col>
                      <Col md={12} className="mb-2">
                        <FormGroup className="has-label d-flex flex-column align-items-start">
                          <Label>Address</Label>
                          <span className="small-text">
                            {publisherTabData?.address || "-"}
                          </span>
                        </FormGroup>
                      </Col>

                      <Col md={6} className="mb-3">
                        <FormGroup className="has-label">
                          <Label>Sites</Label>

                          {publisherTabData?.publisherSites?.length ? (
                            <Table
                              bordered
                              responsive
                              size="sm"
                              className="mb-0"
                            >
                              <thead className="thead-light">
                                <tr>
                                  <th style={{ width: "60px" }}>Sr.no</th>
                                  <th>Site Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {publisherTabData?.publisherSites.map(
                                  (site, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{site?.url}</td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </Table>
                          ) : (
                            <span className="small-text text-muted ml-1">
                              No sites available
                            </span>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={6} className="mb-3">
                        <FormGroup className="has-label">
                          <Label>Bundle IDs</Label>

                          {publisherTabData?.publisherBundleIDs?.length ? (
                            <Table
                              bordered
                              responsive
                              size="sm"
                              className="mb-0"
                            >
                              <thead className="thead-light">
                                <tr>
                                  <th style={{ width: "60px" }}>Sr.no</th>
                                  <th>Bundle ID</th>
                                </tr>
                              </thead>
                              <tbody>
                                {publisherTabData?.publisherBundleIDs.map(
                                  (bundle, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{bundle?.bundleID}</td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </Table>
                          ) : (
                            <span className="small-text text-muted ml-1">
                              No bundle IDs available
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="insertion-orders">
                <ReactBsTable
                  title={`${
                    publisherTabData?.companyName || "Publisher"
                  } - Insertion Orders`}
                  description="Publisher specific insertion orders"
                  data={ioData}
                  columns={ioColumns}
                  keyField="ID"
                  addbtntext="Add IO"
                  showAddbtn={true}
                  onAddBtnClick={() => {
                    setSelected(null);
                    setFormState({
                      values: {
                        status: true,
                        publisher: publisherId,
                      },
                      errors: {},
                    });
                    setModalOpen(true);
                  }}
                  page={pageNum}
                  sizePerPage={pageSize}
                  totalRecords={totalRecords}
                  onPageChange={handlePageChange}
                  onSortChange={handleSortChange}
                  handleSizePerPageChange={handleSizePerPageChange}
                  enablePageSizeManagement={true}
                  defaultSortField={sortConfig.dataField}
                  defaultSortOrder={sortConfig.sortOrder}
                  showLoader={showLoader}
                />
              </TabPane>

              {/* Updated Billing Information Tab */}
              <TabPane tabId={"billing-info"}>
                <h3 className="page-heading">
                  <span>{publisher?.companyName}</span>
                  <span> - </span>
                  <span>Billing Information</span>
                </h3>
                  {userRole === "SUPER_ADMIN" && (
                    <div className="text-right mb-3">
                      <Button
                          className="btn-gradient-primary mr-2"
                          onClick={() => setIsBankModalOpen(true)}
                      >
                       Add Bank Details
                      </Button>
                    </div>
                  )}

  <BankDetailModal
        isOpen={isBankModalOpen}
        toggleModal={() => setIsBankModalOpen(false)}
        onSubmit={handleBankSubmit}
        onBillingComplete={() => {
          notify("success", "Bank details added successfully!");
          setIsBankModalOpen(false);
          Promise.all([getBillingInfo(), getBankHistory()]);
        }}
        legalEntityName={publisherTabData?.companyName || ""}
      />


                {hasBillingInfo ? (
                  <Row className="justify-content-center">
                    <Col md={12} lg={12}>
                      <Row className="px-3">
                        {/* Left Column */}
                        <Col md={6}>
                          <BillingField
                            label="Legal Entity Name"
                            value={getBillingValue("companyName")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="legal_entity_name"
                          />
                          <BillingField
                            label="Bank Name"
                            value={getBillingValue("bank_name")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="bank_name"
                          />
                          <BillingField
                            label="Country"
                            value={getBillingValue("country")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="country"
                          />
                          <BillingField
                            label="TRN/VAT ID"
                            value={getBillingValue("trn_vat_id")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="trn_vat_id"
                          />
                          <BillingField
                            label="Payment Currency"
                            value={getBillingValue("payment_currency")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="payment_currency"
                          />
                          <BillingField
                            label="Payment Terms"
                            value={getBillingValue("payment_terms")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="payment_terms"
                          />
                          <BillingField
                            label="Minimum Payout"
                            value={getBillingValue("minimum_payout")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="minimum_payout"
                          />
                           <BillingField
                            label="Tax Residency"
                            value={getBillingValue("tax_residency")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="tax_residency"
                          />
                        
                        </Col>

                        {/* Right Column */}
                        <Col md={6}>
                          <BillingField
                            label="Billing Address"
                            value={getBillingValue("billing_address")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="billing_address"
                          />
                          <BillingField
                            label="Bank Account"
                            value={getBillingValue("bank_account")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="bank_account"
                          />
                          <BillingField
                            label="Account Number"
                            value={getBillingValue("account_number")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="account_number"
                          />
                      
                          <BillingField
                            label="IBAN"
                            value={getBillingValue("iban")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="iban"
                          />
                          <BillingField
                            label="SWIFT/BIC"
                            value={getBillingValue("swift_bic") || getBillingValue("swift_code")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="swift_bic"
                          />
                          <BillingField
                            label="IFSC Code"
                            value={getBillingValue("ifsc_code")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="ifsc_code"
                          />
                    
                          <BillingField
                            label="Invoice Email"
                            value={getBillingValue("invoice_email")}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="invoice_email"
                          />

                            <BillingField
                            label="Approval Status"
                            value={getStatusBadge(getBillingValue("approval_status"))}
                            isEditing={isEditing}
                            onChange={billingInfoHandleChange}
                            name="invoice_email"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <div className="text-center my-4">
                    <span className="text-muted">
                      No Billing Information Available
                    </span>
                  </div>
                )}

                <div className="mt-4">
                  <ReactBsTable
                    title="Bank Details History"
                    description="View all previous bank details"
                    data={bankHistory}
                    columns={bankHistoryColumns}
                    keyField="id"
                    page={1}
                    sizePerPage={10}
                    totalRecords={bankHistory.length}
                    showLoader={historyLoader}
                    bordered
                    hover
                    enablePageSizeManagement={false}
                    showAddbtn={false}
                    showColumnsBtn={false}
                    exportCSVBtnShow={false}
                  />
                </div>
              </TabPane>

              <TabPane tabId={"actions"}>
                <h3 className="page-heading">
                  <span>{publisher?.companyName}</span>
                  <span> - </span>
                  <span>Actions</span>
                </h3>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="action_documnet"
                  accept=".pdf,.doc,.cocx,.csv"
                />
                <CardSection
                  header={"Advertiser Block List"}
                  btntext={"Download Blocklist CSV"}
                  onClick={downloadBlocklistCsv}
                  showDownloadIcon={true}
                  showDivider={csvDocument?.blockList?.fileUrl ? true : false}
                  rightContent={
                    <>
                      {csvDocument?.blockList?.fileUrl && (
                        <>
                          <h5 className="meta-text">
                            File Name :{" "}
                            {getTrimmedFileName(
                              csvDocument?.blockList?.fileUrl,
                            )}
                          </h5>
                          <h5 className="meta-text">
                            Last Updated Date :{" "}
                            {csvDocument?.blockList.createdAt || "-"}
                          </h5>

                          <div className="d-flex align-items-center">
                            <Button
                              size="sm"
                              onClick={() =>
                                openCsvPreviewModal(
                                  csvDocument?.blockList?.fileUrl,
                                )
                              }
                            >
                              <i className="fa fa-eye mr-1 mb-0 text-black" />
                              View Advertiser Block List
                            </Button>
                            <Button
                              size="sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                downloadBlocklistCsv();
                              }}
                            >
                              <i className="fa fa-download text-info pointer" />
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  }
                  collapseId="1"
                  tableHeading={"Publisher BlockList CSV"}
                  tableDescription={"Publisher BlockList All CSV Logs"}
                  data={csvData?.AdvertiserBlockListLogs}
                  onPageChange={(p) => setPageNum(p)}
                />
                <hr />
                <input
                  type="file"
                  ref={adsFileInputRef}
                  onChange={uploadAdsFile}
                  className="action_documnet"
                  accept=".txt,text/plain"
                />
                <CardSection
                  header={`ads.txt File`}
                  btntext={"Upload ads.txt"}
                  onClick={handleUploadAdsFile}
                  showuploadIcon={true}
                  showDivider={csvDocument?.adsDocument?.fileUrl ? true : false}
                  rightContent={
                    csvDocument?.adsDocument?.fileUrl && (
                      <>
                        <h5 className="meta-text">
                          FileName :{" "}
                          {getTrimmedFileName(
                            csvDocument?.adsDocument?.fileUrl,
                          )}
                        </h5>
                        <h5 className="meta-text">
                          Last Updated Date :
                          {csvDocument?.adsDocument.createdAt || "-"}
                        </h5>
                        <div className="d-flex align-items-center">
                          <Button
                            size="sm"
                            onClick={() =>
                              openCsvPreviewModal(
                                csvDocument?.adsDocument?.fileUrl,
                              )
                            }
                          >
                            <i className="fa fa-eye mr-1 mb-0 text-black" />
                            View ADS.txt
                          </Button>
                          <Button
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadADSListCsv();
                            }}
                          >
                            <i className="fa fa-download text-info pointer" />
                          </Button>
                        </div>
                      </>
                    )
                  }
                  collapseId="2"
                  tableHeading={"Publisher Ads.txt files"}
                  tableDescription={"Publisher Ads.txt all files logs"}
                  data={csvData?.AdsListLogs}
                />
                <hr />
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={uploadAdvertizeListFile}
                  className="action_documnet"
                  accept=".csv"
                />
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
        <DynamicFormModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          title={isEditMode ? "Edit Insertion Order" : "Add Insertion Order"}
          fields={insertionOrderFormFields(
            dropDownData?.publisherData.options || [],
            disabledPublisherDropdown,
          )}
          formData={formState.values}
          errors={formState.errors}
          onChange={handleChange}
          onSubmit={handleSubmit}
          showDocumentUpload={true}
          formState={formState}
          setFormState={setFormState}
          isEditMode={isEditMode}
          trueLabel={INSERTION_ORDER_STATUS_LABELS.TRUE}
          falseLabel={INSERTION_ORDER_STATUS_LABELS.FALSE}
          showLoader={showLoader}
        />
        <DocumentPreviewModal
          isOpen={!!preview}
          toggle={() => setPreview(null)}
          document={preview}
        />
      </Container>
    </>
  );
}

export default PublisherDetails;